function getRandomString(length: number): string {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, length);
}

interface UserKeyResponse {
  userKey: string;
}

export async function generateUserKey(): Promise<UserKeyResponse> {
  let epochTimeInMS = Math.floor(Date.now());
  const maxReqTime = 4234;
  const prefix = '0x' + getRandomString(3);
  const suffix = getRandomString(5);
  const preConstant = getRandomString(5);
  const postConstant = getRandomString(5);
  const secretKey = getRandomString(12);

  epochTimeInMS += maxReqTime;

  const keyString = `${prefix}${preConstant}${epochTimeInMS}${postConstant}${suffix}${secretKey}`;

  const encoder = new TextEncoder();
  const bytes = encoder.encode(keyString);
  const userKey = btoa(String.fromCharCode.apply(null, Array.from(bytes)));
  return { userKey };
}
